// HelpSuccessMessage.tsx
import React from 'react';
import { Typography, Box, Button } from '@mui/material';
import { colors } from '../../constants/globalcss';
import { sizes } from '../../styles/commonStyles';
// import sizes from the correct module or define sizes locally if needed

const HelpSuccessMessage = ({ onClose }: { onClose: () => void }) => (
  <Box sx={{ textAlign: 'center', py: sizes.spacing.lg }}>
    <Typography
      variant="h6"
      sx={{
        color: colors.text.primary,
        fontWeight: sizes.fontWeight.semiBold,
      }}
    >
      Thank you! Your request has been submitted.
      <br />
      Our support team will contact you soon to assist you.
      <br />
      We appreciate your patience.
    </Typography>
    <Button
      variant="contained"
      color="primary"
      onClick={onClose}
      sx={{
        mt: sizes.spacing.lg,
        borderRadius: sizes.borderRadius.medium,
        minWidth: sizes.dimensions.minButtonWidth,
        padding: `${sizes.spacing.md} ${sizes.spacing.lg}`,
        backgroundColor: colors.primary,
        color: colors.background.paper,
        fontWeight: sizes.fontWeight.semiBold,
      }}
    >
      Close
    </Button>
  </Box>
);

export default HelpSuccessMessage;
